// El backend marca la denegación de programa con una clave estable, no con el texto del mensaje.
export const PROGRAM_ACCESS_DENIED_ERROR_KEY = 'PROGRAM_ACCESS_DENIED';

// Transitorio (18/09/2026): api-v3 aún responde solo con el texto. Retirar cuando TAN-10358
// despliegue el errorKey en dev1.
export const PROGRAM_ACCESS_DENIED_MESSAGE = 'Program access denied';

// El interceptor no puede navegar por el router: avisa y el boundary revalida y cierra la vista.
export const PROGRAM_ACCESS_REVOKED_EVENT = 'editorial-program-access-revoked';

export const PROGRAM_ROUTE_TYPE = { catalog: 'catalog', content: 'content', program: 'program', unknown: 'unknown' };

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const CONTENT = /^\/(?:content|contents\/activities|fixedlayout-editor(?:demo)?|viewer|viewer-v1|viewer-v2|viewer-nutrient-standalone)\/([^/]+)(?:\/|$)/;
const PROGRAM = /^\/program\/(?:mint-stand-alone\/)?([^/]+)(?:\/|$)/;

export function editorialProgramRoute(pathname) {
  if (pathname === '/programs' || pathname === '/programs/') return { type: PROGRAM_ROUTE_TYPE.catalog };

  const content = CONTENT.exec(pathname);
  if (content) return GUID.test(content[1]) ? { type: PROGRAM_ROUTE_TYPE.content, guid: content[1] } : { type: PROGRAM_ROUTE_TYPE.unknown };

  const program = PROGRAM.exec(pathname);
  return program && GUID.test(program[1]) ? { type: PROGRAM_ROUTE_TYPE.program, guid: program[1] } : { type: PROGRAM_ROUTE_TYPE.unknown };
}
